import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { augmentPaging } from '~/infrastructure/paging';
import { ApiServiceBase, API_NAMES } from '~/services/api';
import { map } from 'rxjs/operators';
import { createHttpParams } from '~/infrastructure/http/params';
import { AdjustAuthorizationActionModel } from '~/models/AdjustAuthorizationActionModel';

@Injectable({ providedIn: 'root' })
export class AdjustInventoryTransactionsService extends ApiServiceBase {
  constructor(injector: Injector, private http: HttpClient) {
    super(injector);
    this.setBase(API_NAMES.stocks);
  }

  createAdjustInventory(model: any) {
    return this.client.post(this._url(), model)
  }

  getAdjustInventoryHistory(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<any[]>(this._url(`/grid-data`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  MostQtyChange(top: number = 10) {
    return this.client.get(this._url(`/MostQtyChange/${top}`));
  }

  AdjustTransactionPerUser(top: number = 10) {
    return this.client.get(this._url(`/AdjustTransactionPerUser/${top}`));
  }

  NumberOfAdjustmentsInXMonths(top: number = 10) {
    return this.client.get(this._url(`/NumberOfAdjustmentsInXMonths/${top}`));
  }

  getAdjustAuthorization(paramsObj?: any, model?: any) {
    paramsObj = paramsObj || {};
    paramsObj.view = 'summary';
    let params = createHttpParams(paramsObj);

    return this.http
      .post<any[]>(this._url(`/grid-data_Authorization`), model, {
        params,
        observe: 'response',
      })
      .pipe(map(augmentPaging));
  }

  updateAuthorizationStatus(model: AdjustAuthorizationActionModel) {
    return this.client.post(this._url(`/Authorization/UpdateStatus`), model);
  }

  private _url(v?: string | undefined) {
    v = v || '';
    return this.url(`/AdjustInventoryTransaction${v}`);
  }
}
